import { render } from "./CalculatorTorispleHeadPressConcave.vue?vue&type=template&id=2905b60f&scoped=true"
import script from "./CalculatorTorispleHeadPressConcave.vue?vue&type=script&lang=js"
export * from "./CalculatorTorispleHeadPressConcave.vue?vue&type=script&lang=js"

import "./CalculatorTorispleHeadPressConcave.vue?vue&type=style&index=0&id=2905b60f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2905b60f"]])

export default __exports__